<template>
  <div>
    <div style="margin: 8px">
      <span>最长边:</span>
      <el-input-digit
        v-model.number="volumeData.volumeLen"
        placeholder="请输入"
        nullable
        format="#.#"
        style="width: 100px"
        @input="handleInput"
      >
        <span>cm</span>
      </el-input-digit>
    </div>
    <div style="margin: 8px">
      <span>次长边:</span>
      <el-input-digit
        v-model.number="volumeData.volumeWidth"
        placeholder="请输入"
        nullable
        format="#.#"
        style="width: 100px"
        @input="handleInput"
      >
        <span>cm</span>
      </el-input-digit>
    </div>
    <div style="margin: 8px">
      <span>最短边:</span>
      <el-input-digit
        v-model.number="volumeData.volumeHeight"
        placeholder="请输入"
        nullable
        format="#.#"
        style="width: 100px"
        @input="handleInput"
      >
        <span>cm</span>
      </el-input-digit>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VolumeInput',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: Object,
      default() {
        return {
          volumeLen: null,
          volumeWidth: null,
          volumeHeight: null
        };
      }
    }
  },
  computed: {
    volumeData: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('change', val);
      }
    }
  },
  methods: {
    handleInput() {
      this.$emit('change', this.volumeData);
    }
  }
};
</script>

<style lang="scss" scoped>
</style> 